import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { rem } from 'polished';
import { FlexCol, FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { SvgIcon, IconType } from '../General/SvgIcon';
import { getDownloadFileInfo } from '../selectors';
import { ButtonLink } from '../General/Button';
import { ZemplinLoaderWrapper } from '../../..';

interface Props {
  addedToWishlist: boolean;
  mobile?: boolean;
  catalog?: boolean;
  onClick?: (add: boolean) => void;
}

function AddToWishlsit({ addedToWishlist, mobile, catalog, onClick }: Props) {
  const [checked, setChecked] = React.useState(addedToWishlist);

  React.useEffect(() => {
    setChecked(addedToWishlist);
  }, [addedToWishlist]);

  const handleOnClick = () => {
    setChecked(!checked);
    if (onClick) {
      onClick(!checked);
    }
  };
  const [showTooltip, setShowTooltip] = React.useState(false);
  const handleMouseEnter = () => setShowTooltip(true);
  const handleMouseLeave = () => setShowTooltip(false);

  return (
    <WrapperLink
      mobile={mobile}
      catalog={catalog}
      onClick={handleOnClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {showTooltip && !catalog && <Tooltip>{__('Obľúbené položky')}</Tooltip>}
      <StyledSvgIcon
        icon={checked ? IconType.fullHeart : IconType.heart}
        alt="Checkbox polovične vybraný"
        width={24}
        height={24}
      />
    </WrapperLink>
  );
}

const WrapperLink = styled(ButtonLink)<{ mobile?: boolean; catalog?: boolean }>`
  background-color: rgba(255, 78, 0, 0.08);
  border-radius: ${rem(4)};
  font-size: ${rem(16)};
  line-height: ${rem(18)};
  letter-spacing: 0;
  color: #000000;
  text-transform: none;
  margin-left: ${rem(16)};
  padding: ${rem(8)} ${rem(14)};
  max-width: ${rem(48)};

  ${({ theme, mobile }) =>
    theme.mediab.l1300`
      position: absolute;
      right: 0;
      ${mobile ? `bottom: ${rem(98)};` : `top: -${rem(68)};`}
  `}

  ${({ theme }) => theme.mediab.s450`
    width: ${rem(48)};
    right: -${rem(10)};
    top: -${rem(48)}
  `}

  &:hover {
    background-color: rgba(255, 78, 0, 0.14);
    cursor: pointer; // Change the cursor to a hand pointer on hover
  }
  border-radius: ${({ catalog }) => (catalog ? '50%' : `${rem(4)}`)};
`;

const StyledSvgIcon = styled(SvgIcon)`
  &:hover {
    cursor: pointer;
  }
`;

const fadeIn = keyframes`
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Tooltip = styled.div`
  position: absolute;
  top: -40px;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 5px;
  border-radius: 4px;
  width: auto;
  white-space: nowrap;
  text-align: center;
  font-size: 14px;
  line-height: 18px;
  padding: ${rem(5)} ${rem(12)};
  animation: ${fadeIn} 0.3s ease-out;
  font-weight: 500;

  ::after {
    content: '';
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 8px solid rgba(0, 0, 0, 0.8);
  }
`;

export { AddToWishlsit };
